(function () {
  'use strict';

  // One stable listener survives Buddha/Shopify navigation replacement.
  if (window.cacbWishlistIntegrationLoaded) return;
  window.cacbWishlistIntegrationLoaded = true;

  var readySwat = null;
  var boundEventLayer = null;
  var pendingLink = null;
  var pendingTimer = null;
  var statusElement = null;
  var navigationRoots = 'main-navigation, #proxy-nav, .mobile-navigation-drawer';

  function statusFor(link) {
    var root = link.closest(navigationRoots);
    if (!root) return null;
    var status = root.querySelector('.cacb-wishlist-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'cacb-wishlist-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.hidden = true;
      root.appendChild(status);
    }
    return status;
  }

  function setStatus(link, text) {
    var status = statusFor(link);
    if (status) {
      status.textContent = text;
      status.hidden = !text;
      statusElement = text ? status : null;
    }
  }

  function cancelPending() {
    if (statusElement) {
      statusElement.textContent = '';
      statusElement.hidden = true;
    }
    statusElement = null;
    pendingLink = null;
    clearTimeout(pendingTimer);
    pendingTimer = null;
  }

  function launch(link) {
    if (!link.isConnected) return;
    try {
      readySwat.ui.open();
      setStatus(link, '');
      var drawer = link.closest('.mobile-navigation-drawer');
      var closeButton = drawer && drawer.querySelector('.mobile-nav-toggle');
      if (closeButton && document.body.classList.contains('enable-mobile-nav-transition')) {
        // Use the existing theme close behavior; do not replace its scroll state.
        closeButton.click();
      }
    } catch (error) {
      setStatus(link, 'Your wishlist could not open. Please try again.');
      console.error('CACB wishlist launch failed', error);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest && target.closest('a[href="#swym-wishlist"]');
    if (!link || !link.closest(navigationRoots)) {
      cancelPending();
      return;
    }
    cancelPending();
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      // Preserve the browser's default, even if Swym previously bound this
      // anchor with an unconditional preventDefault handler.
      event.stopPropagation();
      return;
    }

    // Capture only this navigation launcher. Prevent old direct Swym bindings
    // and the theme's submenu handler from opening it again or changing the hash.
    event.preventDefault();
    event.stopPropagation();
    if (readySwat && readySwat.ui && typeof readySwat.ui.open === 'function') {
      launch(link);
      return;
    }

    setStatus(link, 'Your wishlist is loading…');
    pendingLink = link;
    // Keep one explicit open request briefly; never open unexpectedly later.
    pendingTimer = setTimeout(function () {
      if (pendingLink && pendingLink.isConnected) {
        setStatus(pendingLink, 'Your wishlist is still loading. Please try again in a moment.');
      }
      pendingLink = null;
      pendingTimer = null;
    }, 10000);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') cancelPending();
  });
  window.addEventListener('pagehide', cancelPending);

  function refreshThemeCart() {
    // Symmetry listens to this event in both CartForm and PageHeader.
    // Never add the product again or force a second cart panel to open.
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    readySwat = swat;
    var eventLayer = swat && swat.evtLayer;
    if (eventLayer && eventLayer !== boundEventLayer) {
      if (boundEventLayer) {
        boundEventLayer.removeEventListener('sw:addedtocart', refreshThemeCart);
        boundEventLayer.removeEventListener('sw:addedalltocart', refreshThemeCart);
      }
      eventLayer.addEventListener('sw:addedtocart', refreshThemeCart);
      eventLayer.addEventListener('sw:addedalltocart', refreshThemeCart);
      boundEventLayer = eventLayer;
    }
    if (pendingLink && swat && swat.ui && typeof swat.ui.open === 'function') {
      var link = pendingLink;
      cancelPending();
      launch(link);
    } else if (swat && swat.ui && typeof swat.ui.open === 'function') {
      cancelPending();
    }
  });
}());
